import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { DriveLoader } from "@/components/DriveLoader";
import { TravelTicker } from "@/components/TravelTicker";
import { api } from "@/lib/api";
import { getSessionId } from "@/lib/session";
import { getAttribution } from "@/lib/attribution";

export function SiteLayout() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const sp = new URLSearchParams(window.location.search);
    const attr = getAttribution();
    api.post("/pageview", {
      path: location.pathname,
      session_id: getSessionId(),
      referrer: document.referrer || attr.landing_referrer || undefined,
      utm_source: sp.get("utm_source") || attr.utm_source || undefined,
      utm_medium: sp.get("utm_medium") || attr.utm_medium || undefined,
      utm_campaign: sp.get("utm_campaign") || attr.utm_campaign || undefined,
    }).catch(() => {});
  }, [location.pathname]);

  return (
    <div className="App min-h-screen flex flex-col">
      <DriveLoader />
      <Header />
      {!["/outbound", "/privacy", "/terms", "/affiliate-disclosure", "/about", "/contact"].some((p) => location.pathname.startsWith(p)) && <TravelTicker />}
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}
